<div>
    <nz-divider
        *ngIf="!!this.option.displayName"
        class="no-margin"
        nzPlain="true"
        [nzText]="text"
        nzOrientation="left"
    >
        <ng-template #text>
            <div class="sider-divider-text">
                {{ this.option.displayName.toUpperCase() }}
            </div>
        </ng-template>
    </nz-divider>
    <div style="width: 100%">
        <nz-select
            [ngModel]="selectedOptionValuesViewModel"
            nzMode="multiple"
            (ngModelChange)="onSelectedViewOptionsModelChange($event)"
            [nzAllowClear]="true"
            [nzDropdownMatchSelectWidth]="false"
            [nzMaxTagCount]="nzMaxTagCount"
            [nzMaxTagPlaceholder]="tagPlaceHolder"
            nzPlaceHolder="SELECT COLUMNS"

            nzSize="small"
            [nzShowArrow]="true"
        >
            <nz-option
                *ngFor="let option of availableOptionsViewModel"
                [nzLabel]="option.label"
                [nzValue]="option.value"
            ></nz-option>
        </nz-select>
        <ng-template #tagPlaceHolder let-selectedList>{{
            selectedValuesPill()
        }}</ng-template>
    </div>
</div>
